"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrotaskDelay = void 0;
/**
 * Can be passed into the Delayed to defer using a microtask
 * */
exports.MicrotaskDelay = Symbol('MicrotaskDelay');
